import { Language } from './i18n'

export function formatCurrency(value: number | null | undefined, language: Language = 'ko'): string {
  const num = typeof value === 'number' ? value : 0
  const formatted = num.toLocaleString(language === 'ko' ? 'ko-KR' : 'en-US')
  const unit = language === 'ko' ? '원' : '$'
  return `${formatted}${unit}`
}

